import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\AdminPanel\IncomingMessagesController::index
* @see app/Http/Controllers/AdminPanel/IncomingMessagesController.php:17
* @route '/admin-panel/incoming-messages'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/admin-panel/incoming-messages',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AdminPanel\IncomingMessagesController::index
* @see app/Http/Controllers/AdminPanel/IncomingMessagesController.php:17
* @route '/admin-panel/incoming-messages'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AdminPanel\IncomingMessagesController::index
* @see app/Http/Controllers/AdminPanel/IncomingMessagesController.php:17
* @route '/admin-panel/incoming-messages'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AdminPanel\IncomingMessagesController::index
* @see app/Http/Controllers/AdminPanel/IncomingMessagesController.php:17
* @route '/admin-panel/incoming-messages'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\AdminPanel\IncomingMessagesController::index
* @see app/Http/Controllers/AdminPanel/IncomingMessagesController.php:17
* @route '/admin-panel/incoming-messages'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AdminPanel\IncomingMessagesController::index
* @see app/Http/Controllers/AdminPanel/IncomingMessagesController.php:17
* @route '/admin-panel/incoming-messages'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AdminPanel\IncomingMessagesController::index
* @see app/Http/Controllers/AdminPanel/IncomingMessagesController.php:17
* @route '/admin-panel/incoming-messages'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

const incomingMessages = {
    index: Object.assign(index, index),
}

export default incomingMessages